import {gsap} from "gsap";
import {Draggable} from "gsap/Draggable";
import {Observer} from "gsap/Observer";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(Draggable, Observer, ScrollTrigger, SplitText);

export {gsap};
export {Draggable};
export {Observer};
export {ScrollTrigger};
export {SplitText};
